import React from "react";
import { useFormContext } from "react-hook-form";
import useShowImage from "../../../../../../hooks/useShowImage";
import PhotoThumbnailStrip, {
  StripPhoto,
} from "../../../../../../components/common/PL/PicturePreview/PhotoThumbnailStrip";
import "./ObservationsReadOnlyImageStrip.css";

type ObservationsReadOnlyImageStripProps = {
  names: string[];
  label: string;
};

/**
 * Fotos de sólo lectura de un ingreso, leídas de campos del formulario. La tira en sí vive en
 * `PhotoThumbnailStrip`, que también usa el modal "Ver más" de la vista por vehículo.
 */
const ObservationsReadOnlyImageStrip: React.FC<ObservationsReadOnlyImageStripProps> = ({
  names,
  label,
}) => {
  const { watch } = useFormContext();
  const getImage = useShowImage();

  const photos: StripPhoto[] = [];
  names.forEach((name) => {
    const value = watch(name);
    if (value && typeof value === "string") {
      photos.push({ url: getImage(value), label: name });
    }
  });

  if (photos.length === 0) return null;

  return (
    <div className="readOnlyImageStripContainer">
      <label className="readOnlyImageStripLabel">{label}</label>
      <PhotoThumbnailStrip photos={photos} />
    </div>
  );
};

export default ObservationsReadOnlyImageStrip;
